import React, { useState } from "react";

import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import variables from "../../constants/assets/variables";
import NoFooterModal from "../Common/NoFooterModal";
import Errors from "../../constants/Errors.json";
import * as BulkUploadDriverSecondaryLocalityActions from "../../store/actions/BulkUploadDriverSecondaryLocalityMapping";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import InformationBar from "../Common/InformationBar";
import {
  Link,
  BottomSectionModal,
  UploadCsvOption,
  NotesSection,
} from "../../constants/assets/containers";
import FileUpload from "../Common/FileUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const SAMPLE_URL = `${
  process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}${"/sample/bulk_upload_driver_secondary_locality_mapping.csv"}`
    : ""
}`;

const FileUploadModal = ({ getUploadUrl, setStatus }) => {
  const history = useHistory();

  //csv file upload specifics
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [file_path, setFile_path] = useState("");
  const [priority, setPriority] = useState("ADD");
  const [loadingBtn, setLoadingBtn] = useState(false);

  const handleClose = () => {
    history.push("/");
  };

  const handleSubmit = (e) => {
    setLoadingBtn(true);
    e.preventDefault();
    getUploadUrl({
      filename: "bulk_upload_driver_secondary_locality_mapping",
      action: priority,
    }).then((res) => {
      setTimeout(() => setLoadingBtn(false), 3000);
      if (res) {
        setFile_path(res.file_path);
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
        setPriority(priority);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const handlePriorityChange = (key, val) => {
    if (val === "Remove") {
      setPriority("REMOVE");
    } else {
      setPriority("ADD");
    }
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "";
  };

  return (
    <BulkUploadDriverSecondaryLocalityModal>
      <NoFooterModal
        header
        heading="Driver Secondary Locality Mappings upload"
        handleClose={handleClose}
        id="bulkUploadDriverSecondaryLocalityModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="assignCourse"
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
          options={["Add", "Remove"]}
          handleChange={handlePriorityChange}
          keyToChange={priority}
          placeholder="Action"
          showCross={true}
          id="fileTypeDropdown"
          showPagination={false}
          value={"Add"}
          labelWidth="fit-content"
        />

        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl="/driver-locality/secondary-mapping-bulk-upload/ack"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            validationType={"BulkUploadDriverSecondaryLocality"}
            acceptTypes=".csv, .xls, .xlsx"
            extraParamsAckObj={{
              file_path: file_path,
              callback_key: callback_key,
              presign_url: presign_url,
              priority: priority,
            }}
          />
        </UploadCsvOption>
        
        <NotesSection>
          <InformationBar sampleUrl={SAMPLE_URL} instructions={instructions} />
        </NotesSection>
      </NoFooterModal>
    </BulkUploadDriverSecondaryLocalityModal>
  );
};

const BulkUploadDriverSecondaryLocalityModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadDriverSecondaryLocalityActions.bulkUploadDriverSecondaryLocality,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);